<div class="ai-question">
    <div class="avatar" *ngIf="user">
        <core-avatar-img [user]="user" [size]="40"> </core-avatar-img>
    </div>
    <div class="content" [innerHTML]="value.question">{{value.question}}</div>
</div>
